/*
 * SuccessScreen.styles.js — ARGO · Trải nghiệm hoàn tất
 */
import styled, { keyframes } from 'styled-components';

const BLUE   = '#00C2FF';
const PURPLE = '#7B61FF';

const pulse = keyframes`
  0%,100% { opacity:.55; transform:scale(.98); }
  50%      { opacity:.9;  transform:scale(1.02); }
`;

export const Scr = styled.main`
  position: relative;
  width: 100%;
  max-width: 430px;
  min-height: 100svh;
  overflow: hidden;
  padding: calc(34px + env(safe-area-inset-top)) 24px calc(18px + env(safe-area-inset-bottom));
  background:
	radial-gradient(circle at 50% 30%, rgba(0,194,255,.22) 0 1%, transparent 34%),
	radial-gradient(circle at 50% 26%, rgba(123,97,255,.20), transparent 44%),
	linear-gradient(180deg, #06132b 0%, #030816 48%, #030816 100%);

  &::before {
	content: "";
	position: absolute; inset: 0; pointer-events: none;
	background:
	  linear-gradient(90deg, transparent 0 49.75%, rgba(0,194,255,.30) 50%, transparent 50.25%),
	  radial-gradient(circle at 50% 23%, rgba(0,194,255,.34), transparent 1.5px),
	  url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Cg fill='none' stroke='%2300C2FF' stroke-opacity='.045' stroke-width='1'%3E%3Cpath d='M0 40h80M40 0v80'/%3E%3C/g%3E%3C/svg%3E");
		opacity: .95;
  }
	
  &::after {
		content: "";
		position: absolute; left: -15%; right: -15%; top: 195px; height: 380px;
		pointer-events: none; opacity: .72;
		background:
			linear-gradient(to top, rgba(3,8,22,.96), transparent 40%),
			url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='430' height='360' viewBox='0 0 430 360'%3E%3Cg fill='%2305122b' stroke='%2300C2FF' stroke-opacity='.13'%3E%3Cpath d='M0 350h430v10H0z'/%3E%3Cpath d='M8 350V210h23v140zM37 350V250h30v100zM75 350V190h18v160zM104 350V230h30v120zM338 350V215h30v135zM378 350V180h25v170zM410 350V240h20v110zM152 350V270h20v80zM196 350V248h24v102zM258 350V278h28v72z'/%3E%3Cpath d='M12 225h14M42 265h18M80 208h9M111 245h17M345 232h16M384 202h14M414 255h12'/%3E%3C/g%3E%3C/svg%3E") center bottom/100% auto no-repeat;
  }

  @media (min-width: 431px) {
		border-left: 1px solid rgba(0,194,255,.12);
		border-right: 1px solid rgba(123,97,255,.12);
		box-shadow: 0 0 80px rgba(0,0,0,.55);
  }
	
  @media (max-width: 360px) {
		padding-left: 18px;
		padding-right: 18px;
  }
  @media (max-height: 760px) { padding-top: 24px; }
`;

export const LogoWrap = styled.header`
  position: relative; z-index: 3;
  display: flex; justify-content: center;
  margin-bottom: 26px;
  @media (max-height: 760px) { margin-bottom: 13px; }
`;

export const LogoImg = styled.img`
  width: min(286px, 74vw);
  filter: drop-shadow(0 0 18px rgba(0,194,255,.22));
  @media (max-height: 760px) { width: 232px; }
  @media (max-width: 360px)  { width: 245px; }
`;

export const SuccessWrap = styled.section`
  position: relative; z-index: 2;
  height: 200px;
  display: flex; 
  align-items: center; 
  justify-content: center;
  margin-top: -8px;
`;

export const Portal = styled.div`
  position: relative;
  width: 150px; 
  height: 150px;
  border-radius: 50%;
  display: grid; 
  place-items: center;

  &::before {
		content: "";
		position: absolute; 
    inset: 0; 
    border-radius: 50%;
		background: conic-gradient(from 215deg, ${PURPLE}, ${BLUE}, #2074ff, ${PURPLE});
		box-shadow: 0 0 32px rgba(0,194,255,.65), 0 0 70px rgba(123,97,255,.40);
  }
  &::after {
		content: "";
		position: absolute; 
    inset: 8px; 
    border-radius: 50%;
		background: rgba(3,8,22,.76);
		box-shadow: inset 0 0 42px rgba(0,194,255,.14);
  }
`;

export const Rings = styled.div`
  position: absolute; 
  inset: -42px; 
  border-radius: 50%;
  background: repeating-radial-gradient(circle, transparent 0 20px, rgba(0,194,255,.14) 21px 22px);
  opacity: .76;
  animation: ${pulse} 3s ease-in-out infinite;
  @media (max-height: 760px) { inset: -28px; }
  @media (max-height: 660px) { inset: -22px; }
  @media (max-width: 360px)  { inset: -34px; }
`;

export const Spark = styled.span`
  position: absolute;
  width: 5px; 
  height: 5px; 
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 14px ${BLUE}, 0 0 28px ${PURPLE};
  &.s1 { top: -1px;    left: 50%; }
  &.s2 { bottom: -1px; left: 50%; }
`;

export const Tick = styled.div`
  position: relative; 
  z-index: 2;
  width: 120px; 
  height: 84px;
  filter: drop-shadow(0 0 25px rgba(0,194,255,.75));

  &::before, &::after {
		content: "";
		position: absolute; 
    border-radius: 999px;
		background: linear-gradient(135deg, ${BLUE}, ${PURPLE});
  }
  &::before { 
    width:38px; 
    height:105px; 
    left:64px; 
    top:-3px;  
    transform:rotate(42deg);
  }
  &::after  { 
    width:38px; 
    height:72px;  
    left:25px; 
    top:33px;  
    transform:rotate(-45deg); 
  }
  @media (max-height: 760px) { transform: scale(.78); }
`;

export const ContentWrap = styled.section`
  position: relative; z-index: 3;
  text-align: center; margin-top: -5px;
`;

export const Sub = styled.p`
  margin: 11px auto 0; max-width: 335px;
  color: #fff; font-size: clamp(16px, 4.8vw, 19px);
  line-height: 1.48; font-weight: 400;
`;

export const Divider = styled.div`
  height: 1px; 
  width: min(240px, 62vw);
  margin: 26px auto 24px;
  background: linear-gradient(90deg, transparent, rgba(0,194,255,.8), transparent);
  box-shadow: 0 0 10px ${BLUE};
  @media (max-height: 760px) { margin: 18px auto 16px; }
`;

export const Actions = styled.nav`
  position: relative; z-index: 3;
  display: grid; gap: 14px; margin-top: 0;
`;

export const ActionCard = styled.a`
  position: relative;
  border: 0;
  background: linear-gradient(180deg, rgba(7,23,54,.74), rgba(5,14,35,.82));
  border-radius: 18px;
  min-height: 88px;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  color: white;
  text-decoration: none;
  padding: 7px;
  gap: 16px;
  box-shadow: 0 0 22px rgba(0,194,255,.14);
  cursor: pointer;
  overflow: hidden;
  font-family: inherit;

  &::after {
		content: "";
		position: absolute;
		inset: -1px;
		border-radius: inherit;
		padding: 1px;
		background: linear-gradient(135deg, ${BLUE}, transparent 45%, ${PURPLE});
		-webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
  }

  &.purple { box-shadow: 0 0 22px rgba(123,97,255,.16); }
  @media (max-height: 760px) { min-height: 76px; }
  @media (max-height: 660px) { min-height: 68px; }
  @media (max-width: 360px)  { gap: 12px; padding: 12px; }
`;

export const Ico = styled.span`
  width: 58px; 
  height: 58px; 
  flex: 0 0 58px;
  border-radius: 50%; 
  border: 1px solid rgba(0,194,255,.7);
  display: grid; 
  place-items: center;
  background: rgba(0,194,255,.05);
  box-shadow: inset 0 0 14px rgba(0,194,255,.13);

  svg {
		width:31px;
		height:31px;
		stroke:${BLUE};
		fill:none;
		stroke-width:2.2;
  }

  .purple & {
		border-color: rgba(123,97,255,.82);
		svg { stroke: ${PURPLE}; }
  }

  @media (max-width: 360px)  { width:52px; height:52px; flex-basis:52px; }
  @media (max-height: 660px) { width:48px; height:48px; flex-basis:48px; }
`;

export const Txt = styled.span`
  strong {
		display: block;
		font-family: 'Exo 2', sans-serif;
		font-size: 16px;
		line-height: 1.1;
		font-weight: 800;
		text-transform: uppercase;
		letter-spacing: .2px;
    white-space: nowrap;
  }
  span {
		display: block;
		margin-top: 8px;
		color: #d9dfec;
		font-size: clamp(13.5px, 3.8vw, 15px);
  }
`;

export const Arrow = styled.span`
  margin-left: auto;
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  border-top: 4px solid ${BLUE};
  border-right: 4px solid ${BLUE};
  transform: rotate(45deg);
  filter: drop-shadow(0 0 8px currentColor);
  .purple & { border-color: ${PURPLE}; }
`;

export const ShareSection = styled.section`
  position: relative; z-index: 3;
  margin: 29px 0 20px; text-align: center;
  @media (max-height: 760px) { margin: 20px 0 13px; }
`;

export const ShareTitle = styled.div`
  display: flex; 
  align-items: center; 
  justify-content: center;
  gap: 14px; 
  font-family: 'Exo 2', sans-serif;
  font-size: 16px; 
  font-weight: 800; 
  letter-spacing: 1.5px;
  text-transform: uppercase; 
  white-space: nowrap;
  background: linear-gradient(90deg, ${BLUE}, ${PURPLE});
  -webkit-background-clip: text; 
  background-clip: text; 
  color: transparent;

  &::before, &::after {
		content: ""; 
		height: 1px; 
		width: 70px;
  }
  &::before { background: linear-gradient(90deg, transparent, rgba(0,194,255,.6)); }
  &::after  { background: linear-gradient(90deg, rgba(123,97,255,.6), transparent); }
  @media (max-height: 660px) { &::before, &::after { width: 42px; } }
`;

export const ShareRow = styled.div`
  display: flex; 
  justify-content: center;
  gap: 18px; 
  margin-top: 19px;
  @media (max-width: 360px)  { gap: 12px; }
  @media (max-height: 660px) { margin-top: 12px; }
`;

export const ShareBtn = styled.button`
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  border: 1px solid rgba(0,194,255,.55);
  background: rgba(5,18,43,.54); color: ${BLUE};
  box-shadow: 0 0 16px rgba(0,194,255,.14);
  font-size: 25px;
  font-weight: 800;
  cursor: pointer;
  font-family: Arial, sans-serif;

  &:nth-child(3), &:nth-child(4) {
		border-color: rgba(123,97,255,.58);
		color: ${PURPLE};
  }
  svg {
		width:26px;
		height:26px;
		stroke:currentColor;
		fill:none;
		stroke-width:2.1;
  }

  @media (max-width: 360px)  { width:52px; height:52px; }
  @media (max-height: 760px) { width:48px; height:48px; }
`;

export const Security = styled.footer`
  position: relative;
  z-index: 3;
  text-align: center;
  color: rgba(255,255,255,.62);
  font-size: 14px;
  letter-spacing: .3px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  svg {
		width:18px;
		height:18px; stroke:${BLUE};
		fill:none; stroke-width:2;
  }
  @media (max-height: 660px) { display: none; }
  @media (max-width: 360px)  { font-size: 12px; }
`;
